import {Companies, Superstars, TagTeams} from "./models.js";
import {getSuperstarNegotiations} from "./superstar.js";
import {getTagTeamNegotiations} from "./tagTeam.js";

function Negotiation(status = 'negotiating', attemptsRemaining = 3) {

    // Integer
    const offeredAmount = null;
    const monthsToRemove = null;

    // Boolean
    const sendToMainRoster = false;

    // Foreign keys
    const senderCompanyId = null;
    const receiverCompanyId = null;
    const superstarId = null;
    const tagTeamId = null;

    return {
        offeredAmount,
        attemptsRemaining,
        monthsToRemove,
        status,
        sendToMainRoster,
        senderCompanyId,
        receiverCompanyId,
        superstarId,
        tagTeamId,
    };
}

function getNegotiationSenderCompany(negotiation) {
    return Companies.find({'$loki': negotiation.senderCompanyId})[0];
}

function getNegotiationReceiverCompany(negotiation) {
    if (!negotiation.receiverCompanyId) {
        return null
    }
    return Companies.find({'$loki': negotiation.receiverCompanyId})[0];
}

function getNegotiationSuperstar(negotiation) {
    return Superstars.find({'$loki': negotiation.superstarId})[0];
}

function getNegotiationTagTeam(negotiation) {
    return TagTeams.find({'$loki': negotiation.tagTeamId})[0];
}

function getNegotiationTalent(negotiation) {
    if (negotiation.superstarId) {
        return getNegotiationSuperstar(negotiation)
    }
    else {
        return getNegotiationTagTeam(negotiation)
    }
}

function getTalentNegotiations(talent) {
    if (talent.objectName === 'superstar') {
        return getSuperstarNegotiations(talent)
    }
    else if (talent.objectName === 'tagTeam') {
        return getTagTeamNegotiations(talent)
    }
}

export { Negotiation, getNegotiationReceiverCompany, getNegotiationSenderCompany, getNegotiationSuperstar,
    getNegotiationTagTeam, getNegotiationTalent, getTalentNegotiations }
